import { createRoot } from "react-dom/client";
import React from "react";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "normalize.css";
import { RootStore, storesContext } from "@stores";
import { loadState, saveState } from "@src/utils/localStorage";
import { autorun } from "mobx";
import "react-perfect-scrollbar/dist/css/styles.css";
import "rc-notification/assets/index.css";
import "react-loading-skeleton/dist/skeleton.css";
import "rc-slider/assets/index.css";
import "rc-dialog/assets/index.css";
import dayjs from "dayjs";
import ThemeWrapper from "./themes/ThemeProvider";
import GlobalStyles from "@src/themes/GlobalStyles";
import ScrollToTop from "@components/ScrollToTop";

const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const initState = loadState();

const mobxStore = new RootStore(initState);
autorun(
  () => {
    console.dir(mobxStore);
    saveState(mobxStore.serialize());
  },
  { delay: 1000 }
);

const rootElement = document.querySelector("#root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <storesContext.Provider value={mobxStore}>
      <ThemeWrapper>
        <BrowserRouter>
          <ScrollToTop />
          <App />
        </BrowserRouter>
        <GlobalStyles />
      </ThemeWrapper>
    </storesContext.Provider>
  </React.StrictMode>
);
